import { cn } from "@win-reality/react-ui";

import { formatHalfInning } from "../../utils/plateAppearanceFeed";
import { InningHalfIcon } from "../InningHalfIcon";

type HalfInningHeaderProps = {
  inning: number;
  isTopOfInning: boolean;
  isExpanded?: boolean;
  onToggle?: () => void;
  /** Test id for the "Top of 1st" text */
  "data-testid"?: string;
  /** Test id for the Show / Close Details button */
  toggleTestId?: string;
};

export const HalfInningHeader = ({
  inning,
  isTopOfInning,
  isExpanded,
  onToggle,
  "data-testid": testId,
  toggleTestId,
}: HalfInningHeaderProps) => (
  <div className="flex items-center justify-between gap-2 px-3 py-3">
    <div className="flex items-center gap-2">
      <InningHalfIcon isTopInning={isTopOfInning} />
      <span
        data-testid={testId}
        data-inning={inning}
        data-half={isTopOfInning ? "top" : "bottom"}
        className="text-sm text-gray-900 dark:text-white"
      >
        {formatHalfInning(inning, isTopOfInning)}
      </span>
    </div>

    {onToggle && (
      <button
        type="button"
        onClick={onToggle}
        data-testid={toggleTestId}
        data-inning={inning}
        data-half={isTopOfInning ? "top" : "bottom"}
        aria-expanded={isExpanded}
        className={cn(
          // Text
          "text-sm text-gray-900 underline dark:text-white",
          // States
          "hover:no-underline focus:outline-none",
        )}
      >
        {isExpanded ? "Close Details" : "Show Details"}
      </button>
    )}
  </div>
);
